import { useLocation, useNavigate } from "react-router-dom";

export default function useRevalidateParent(revalidateKey = "rv") {
  const nav = useNavigate();
  const loc = useLocation();

  return () => {
    const url = new URL(window.location.href);

    // 1) Use a unique token so consecutive calls always differ (forces revalidation).
    const token = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    url.searchParams.set(revalidateKey, token);

    // 2) Trigger revalidation by navigating with the updated query (replace = no new history entry).
    nav(`${loc.pathname}?${url.searchParams.toString()}`, {
      replace: true, // do not create a new history entry
      preventScrollReset: true, // do not move the scroll
    });

    // 3) After a short delay, remove the key WITHOUT navigation (so it won't revalidate again).
    setTimeout(() => {
      const resetUrl = new URL(window.location.href);

      // 4) Race-safety: only remove if the current value equals the token we set.
      //    If another refresh occurred in the meantime, skip cleanup.
      if (resetUrl.searchParams.get(revalidateKey) === token) {
        resetUrl.searchParams.delete(revalidateKey);

        // 5) Replace the current URL silently. This does NOT trigger React Router navigation/loaders.
        const newHref =
          resetUrl.pathname +
          (resetUrl.searchParams.toString() ? `?${resetUrl.searchParams.toString()}` : "") +
          resetUrl.hash;

        window.history.replaceState(window.history.state, "", newHref);
      }
    }, 5000); // you can tweak this delay if needed
  };
}
